import { format, parseISO } from 'date-fns';
import { convertDateToTimeZone } from './convertDateToTimeZone';

/**
 * Formats a date in correct timezone.
 * @param date
 */
export function formatDate(date: Date | string, formatString: string): string {
	const timezoneDate = convertDateToTimeZone(date);
	return format(timezoneDate, formatString);
}
export function formatUTCDate(
	dateString: string,
	formatString: string,
): string {
	const date = parseISO(dateString); // Parses the date as a local timezone object
	const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000); // Shift to UTC
	return format(utcDate, formatString); // Format as desired
}
